<div class='modal-wrapper'>
  <div class='inner-wrapper'>
    <ion-grid>
      <ion-row>
        <ion-col>
          <div (click)='onDismiss()' class='ion-float-end pointer dismiss-button'>
            <ion-icon color='danger' name='close-outline'></ion-icon>
          </div>
        </ion-col>
      </ion-row>


      <swiper-container #slider>
        @for (question of checklist.questions; track question; let index = $index) {
          <swiper-slide>
            <app-checklist-question
              class='checklist-question'
              [question]='question'
              [checklistType]='checklist.type'
              (answerChanged)='onAnswerChange($event)'
            ></app-checklist-question>
          </swiper-slide>
        }
      </swiper-container>
    </ion-grid>
  </div>
</div>
@if (checklist.questions) {
  <app-slide-control-bar
    [prevActive]='true'
    [nextActive]='checklist.questions.length > checklist.currentIndex && checklist.questions[checklist.currentIndex].answer !== undefined'
    [quantityOfSlides]='checklist.questions.length'
    [index]='checklist.currentIndex'
    (indexChanged)='changeToSlide($event)'
    (slidesCompleted)='checklistCompleted()'
    class='control-bar'
  ></app-slide-control-bar>
}
